import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Card from './ScubaCoursesCard';
import Select from './ScubaCoursesSelect';
import Header from './ScubaCoursesHeader';

export default class ScubaCourses extends Component {
  static propTypes = {
    arrCourses: PropTypes.array
  }

  static defaultProps = {
    arrCourses: []
  }

  state = {
    resortEvents: [],
    resortAbbr: ''
  }

  filterEvents = resort => {
    this.setState({resortEvents: this.props.arrCourses.filter(item => item.rstCode === resort)});
  }

  updateData = (value) => {
    this.setState({resortAbbr: value}, this.filterEvents(value));
  }

  render() {
    const {arrCourses} = this.props;
    const {
      resortEvents,
      resortAbbr
    } = this.state;

    return(
      <div className="courses-sort__wrapper">
        <Select updateData={this.updateData}/>

        {resortEvents.length
          ? <Header
            arrCourses={arrCourses}
            eventsLength={resortEvents.length}
            resortAbbr={resortAbbr}/>
          : ''}

        <div className="courses-sort__cards">
          {
            resortEvents.map((item, index) =>
              (<Card
                key={index}
                cardData={item}/>)
            )
          }
        </div>
      </div>
    );
  }
}
